var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "v-application" },
    [
      _c(
        "v-dialog",
        {
          ref: "dialogSnackModal",
          attrs: { "max-width": "400px" },
          on: { input: _vm.onDialogChange },
          model: {
            value: _vm.show,
            callback: function($$v) {
              _vm.show = $$v
            },
            expression: "show"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "snack-modal-card" },
            [
              _vm.button
                ? _c(
                    "v-btn",
                    {
                      staticClass: "close-button",
                      attrs: { icon: "", small: "" },
                      on: { click: _vm.close }
                    },
                    [
                      _c("icon-svg", {
                        attrs: { name: "close", size: "15", color: "#8e8e8e" }
                      })
                    ],
                    1
                  )
                : _vm._e(),
              _c("v-card-text", { staticClass: "pa-0 px-4" }, [
                _vm.showIcon
                  ? _c(
                      "div",
                      { staticClass: "mb-4" },
                      [
                        _c("icon-svg", {
                          attrs: {
                            size: "40",
                            name: _vm.modalIconName,
                            color: _vm.modalIconColor
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.text
                  ? _c("span", { staticClass: "modal-text" }, [
                      _vm._v(" " + _vm._s(_vm.text) + " ")
                    ])
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }